import { render, staticRenderFns } from "./TemplatesCreate.vue?vue&type=template&id=11383430&"
import script from "./TemplatesCreate.vue?vue&type=script&lang=js&"
export * from "./TemplatesCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports